<template>
  <div class="input-container">
    <label class="name">{{ label }}</label>
    <input
      required
      :type="type"
      :disabled="isDisabled"
      :class="`input col-sm-12 col-md-12 col-lg-12 col-xl-12 ${isInvalidInput} ${textAlign}`"
      :value="maskCurrency(valueInput)"
      @input="valueSelected($event)"
      :placeholder="placeholder"
      @blur="clearInvalidInput"
      ref="inputMoney"
      @focus="selectAll"
    />
    <div class="underline"></div>
  </div>
</template>

<script>
import { mascaraMoeda, maskCurrency } from "../../../utils/maskMoney";
export default {
  props: {
    label: {
      type: [String, Number],
    },
    labelFixed: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    dataInput: {
      type: [String, Number, Function],
    },
    isDisabled: {
      type: Boolean,
    },
    alterTotalValue: {
      type: [String, Number],
    },
    textAlign: {
      type: String,
    },
    change: {
      type: Function,
    },
    labelBackground: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    isInvalidInput: {
      type: String,
    },
    isSelectAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueInput: "",
      maskCurrency: maskCurrency,
    };
  },
  created() {
    this.valueInput = this.dataInput;
  },
  methods: {
    valueSelected(event) {
      this.valueInput = mascaraMoeda(event.target.value);

      this.$emit("update:dataInput", this.valueInput);
      this.$emit("calculateTotal", this.valueInput);
      this.$emit("changed");
    },
    clearInvalidInput() {
      this.$emit("clearInvalidInput");
    },
    selectAll() {
      if (this.isSelectAll) {
        this.$refs?.inputMoney?.select();
      }
    },
  },
};
</script>

<style scoped>
.input-container {
  position: relative;
  width: 100%;
}

label {
  display: block;
  color: #006459;
  font-weight: 600;
  font-size: 13px;
  margin: 0 !important;
}

.input[type="text"] {
  padding: 7px;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  background-color: #f1f1f1;
  color: #333;
  width: 100%;
  outline: none;
}
.input[type="number"] {
  padding: 7px;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  background-color: #f1f1f1;
  color: #333;
  width: 100%;
  outline: none;
}

.underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #4158d0;
  background-image: linear-gradient(
    43deg,
    #006459 0%,
    #029b89 46%,
    #ffcc70 100%
  );
  transition: width 0.3s;
}

.input[type="text"]:focus + .underline {
  width: 100%;
}
</style>